import React, {useState} from "react";
import {useGetFilters} from "../../../hooks/Administrative/useGetFilters";
import {Bounce, toast} from "react-toastify";
import TicketInfo from "../../../components/TicketInfo/TicketInfo";
import TableView from "../../../components/TableView/TableView";
import {useGetCompletedTickets} from "../../../hooks/Administrative/useGetCompletedTickets";

const columns = ['CLIENTE', 'PLANTA', 'SERVICIO', 'ESTADO', 'CLAVE DE TICKET'];

const AdministrativeHistory = () => {
    const [selectedTicket, setSelectedTicket] = useState<string>('');
    const [showTicketInfo, setShowTicketInfo] = useState<boolean>(false);
    const [additionalInfo, setAdditionalInfo] = useState<any>(null);
    const [filters, setFilters] = useState({});
    const {tickets, totalPages, isLoading, page, setPage} = useGetCompletedTickets({filters});
    const {clients, services, states} = useGetFilters();

    const handleOnRowClick = (row: Record<string, any>) => {

        if (row['ESTADO'] === 'Rechazado') {
            toast.warning(
                'El ticket al haber sido rechazado, fue borrado del sistema.',
                {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                }
            );
        } else {
            setSelectedTicket(row['CLAVE DE TICKET']);
            setAdditionalInfo(row);
            setShowTicketInfo(true);
        }
    };

    const handleBack = () => {
        setShowTicketInfo(false);
    };

    return showTicketInfo ? (
        <TicketInfo
            ticketCode={selectedTicket}
            onBack={handleBack}
            additionalInfo={additionalInfo}
            showTicketInfo={setShowTicketInfo}
        />
    ) : (
        <TableView
            title="HISTORIAL DE TICKETS"
            columns={columns}
            filters={filters}
            tickets={tickets}
            totalPages={totalPages}
            isLoading={isLoading}
            page={page}
            clients={clients}
            services={services}
            states={states}
            setFilters={setFilters}
            setPage={setPage}
            disableAddButton={true}
            onRowClick={handleOnRowClick}
        />
    );
};

export default AdministrativeHistory;


